import { render, staticRenderFns } from "./AddressFinancialSponsorForm.vue?vue&type=template&id=6ed7150d&scoped=true&"
import script from "./AddressFinancialSponsorForm.vue?vue&type=script&lang=ts&"
export * from "./AddressFinancialSponsorForm.vue?vue&type=script&lang=ts&"
import style0 from "./AddressFinancialSponsorForm.vue?vue&type=style&index=0&id=6ed7150d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed7150d",
  null
  
)

export default component.exports